import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "ProductCard" })
export default class ProductCard extends Vue {
    public localizer: any = Localizer;
    public optimizedCCTs: string[] = [];

    @Prop() readonly highlightTitle: string;
    @Prop() readonly page: string;
    @Prop() readonly title: string;
    @Prop() readonly description: string;
    @Prop() readonly orderCode: string;
    @Prop() readonly iscct: boolean;
    @Prop() readonly ccts: number[];
    @Prop() readonly imageUrl: string;
    @Prop() readonly linkUrl: string;
    @Prop() readonly lowestPrice: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        if (this.iscct && this.ccts && this.ccts.length != 0) {
            for (const cct of this.ccts) {
                if (cct <= 7000 && cct >= 5000) {
                    this.optimizedCCTs.push("t6500")
                } else if (cct < 5000 && cct >= 3500) {
                    this.optimizedCCTs.push("t4000")
                } else if (cct < 3500 && cct >= 2500) {
                    this.optimizedCCTs.push("t2700")
                }
            }
            this.optimizedCCTs = [...new Set(this.optimizedCCTs)];
        }
    }

    public limit(text: string, length: number) {
        return text.length > length ? text.substring(0, length - 3).trim() + "..." : text;
    }

    public formatPrice(data: string) {
        return new Intl.NumberFormat('it-IT', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseFloat(data));
    }
};